import { cloudChiprApi } from "@/services/cloudchipr.api";
import { infrastructureArchitecturePossibleRegionsThunkArgs } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitecturePossibleRegionsThunk";

export const getInfrastructureArchitecturePossibleRegionsEndpointSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValues.select(
    infrastructureArchitecturePossibleRegionsThunkArgs,
  );
